import React from 'react';
import { ActionCardBase } from '@/src/components/ActionCardBase/ActionCardBase';
import { getContentfulImageApiUrl } from './utils/getContentfulImageApiUrl';

export type ActionCardContent = {
  title: string;
  body?: React.ReactNode;
  inverted?: boolean;
  nonRoundedEdges?: boolean;
  canBeDismissed?: boolean;
  image?: { url?: string; width?: number };
  cta?: { label?: string; action?: () => void };
};

type ActionCardViewProps = {
  cardData: ActionCardContent;
  onClose?: () => void;
  onCtaClick?: () => void;
};

export const ActionCardView = ({
  cardData,
  onClose,
  onCtaClick,
}: ActionCardViewProps) => {
  const imgSrc = getContentfulImageApiUrl(
    cardData.image?.url,
    cardData.image?.width,
  );

  return (
    <ActionCardBase
      title={cardData.title}
      body={cardData.body ? <>{cardData.body}</> : undefined}
      inverted={!!cardData.inverted}
      inline={!cardData.nonRoundedEdges}
      imgSrc={imgSrc}
      onClickClose={cardData.canBeDismissed && onClose ? onClose : undefined}
      onClickCta={
        cardData.cta?.action
          ? () => {
              onCtaClick?.();
              cardData.cta?.action?.();
            }
          : undefined
      }
      ctaTitle={cardData.cta?.label || undefined}
    />
  );
};
